export const SCREEN_TO_EXCLUDE = {
  RULES: 'Rules',
};
